const GolfHubPageStatus = Object.freeze({
  PUBLISHED: 'Published',
  CREATED: 'Created',
  ABSENT: '',
})

export default GolfHubPageStatus
